import { useVerify } from './helpers';
import Loading from '~/components/loading';
import LoginPage from '~/pages/Login';
import { LoginPageProps } from '~/pages/Login/types';

const Authentication = ({
  children,
  ...loginProps
}: React.PropsWithChildren<Partial<LoginPageProps>>) => {
  const { loading, data: isLoggedIn, error } = useVerify();
  if (loading) {
    return <Loading />;
  }
  const Next = () => <>{children}</>;
  if (error) {
    return <LoginPage {...loginProps} error={error} next={Next} />;
  }
  return isLoggedIn ? <Next /> : <LoginPage {...loginProps} next={Next} />;
};

export default Authentication;
